<template>
  <div class="carousel-wrapper" v-if="images">
    <div
      class="columns is-vcentered"
      :class="{ 'is-centered': images.length === 1 }"
    >
      <div class="column is-5 has-text-centered">
        <div class="background" :style="renderBackgroundCurrent" />
      </div>
      <div v-if="images.length > 1" class="column thumbnailContainer">
        <div
          v-if="!isMobile"
          class="columns is-multiline is-centered is-mobile"
        >
          <div
            class="column is-4"
            v-for="(image, index) in images"
            :key="index"
          >
            <div
              :class="[
                highlighted(index) ? 'highlighted' : 'not-highlighted',
                'thumbnail',
              ]"
              @click="current_index = index"
              :style="renderBackgroundNonCurrent(image)"
            >
              <div />
            </div>
          </div>
        </div>
        <div v-else class="over-flow is-flex">
          <div
            class="is-flex-direction-row py-2 px-2"
            v-for="(image, index) in images"
            :key="index"
          >
            <div
              :class="[
                highlighted(index) ? 'highlighted' : 'not-highlighted',
                'thumbnail',
              ]"
              @click="current_index = index"
              :style="renderBackgroundNonCurrent(image)"
            >
              <div />
            </div>
          </div>
        </div>
        <div class="paginationContainer">
          <div
            class="paginationButton paginationNav"
            @click="currentPage !== 1 ? currentPage-- : null"
          >
            &lt;
          </div>

          <div v-for="num in numOfPages" :key="num">
            <div
              v-if="paginationShouldDisplay(num)"
              :class="[
                { selectedPaginationButton: currentPage === num },
                'paginationButton',
                { notClickable: displayElipsis(num) === '...' },
              ]"
              @click="
                displayElipsis(num) !== '...' ? (currentPage = num) : null
              "
            >
              {{ displayElipsis(num) }}
            </div>
          </div>

          <div
            class="paginationButton paginationNav"
            @click="currentPage !== numOfPages ? currentPage++ : null"
          >
            &gt;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      current_index: 0,
      timer: null,
      allImages: [],
      imagesPerPage: 9,
      currentPage: 1,
      numOfPages: null,
      isMobile: false,
    };
  },
  computed: {
    currentSlide() {
      return this.images.filter((image, index) => index === this.current_index);
    },
    renderBackgroundCurrent() {
      return `background-image : url(${this.currentSlide});`;
    },
    images() {
      let startIndex = (this.currentPage - 1) * this.imagesPerPage;
      let endIndex = startIndex + this.imagesPerPage;
      let images = this.allImages.slice(startIndex, endIndex);

      return images;
    },
  },
  methods: {
    changeSlide(delta) {
      let total = this.current_index + delta;
      if (total < 0) {
        this.current_index = this.images.length - 1;
      } else if (total >= this.images.length) {
        this.current_index = 0;
      } else {
        this.current_index += delta;
      }
    },
    renderBackgroundNonCurrent(image) {
      return `background-image : url(${image})`;
    },
    highlighted(index) {
      return index === this.current_index;
    },
    paginationShouldDisplay(num) {
      return (
        this.currentPage === num - 1 ||
        this.currentPage === num - 2 ||
        this.currentPage === num + 1 ||
        this.currentPage === num + 2 ||
        this.currentPage === num ||
        num === 1 ||
        num === this.numOfPages
      );
    },
    displayElipsis(num) {
      return (this.currentPage + 2 === num &&
        this.currentPage + 2 !== this.numOfPages) ||
        (this.currentPage - 2 === num && this.currentPage - 2 !== 1)
        ? "..."
        : num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
  },
  async mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    ({ data: this.allImages } = await axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}/gallery-service/get-images?id=${process.env.VUE_APP_GALLERY_KSUID}`,
      {
        headers: {
          "x-api-key": process.env.VUE_APP_API_KEY,
        },
      }
    ));
    this.numOfPages = Math.ceil(this.allImages.length / this.imagesPerPage);
    this.currentPage = 1;

    document.onkeydown = (e) => {
      e = e || window.event;
      // Left arrow
      if (e.keyCode == "37") {
        if (this.current_index === 0 && this.currentPage !== 1) {
          this.currentPage--;
          this.current_index = this.images.length - 1;
        } else {
          this.changeSlide(-1);
        }
      } else if (e.keyCode == "39") {
        // Right arrow
        if (
          this.current_index === this.images.length - 1 &&
          this.currentPage !== this.numOfPages
        ) {
          this.currentPage++;
          this.current_index = 0;
        } else {
          this.changeSlide(1);
        }
      }
    };
  },
};
</script>

<style scoped>
.background {
  height: 300px;
  max-width: 500px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 2px 5px #8a8a8a;
}

.carousel-wrapper {
  background-position: center;
  padding: 2rem;
  width: 100%;
}

.highlighted {
  border: 2px solid #3d3732;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.mobile-only-display {
  display: none;
}

.notClickable {
  cursor: initial !important;
}

.over-flow {
  max-width: 100%;
  overflow-x: auto;
  margin: auto;
}

.paginationButton {
  height: 2.5rem;
  width: 2.5rem;
  text-align: center;
  line-height: 2.5rem;
  cursor: pointer;
  user-select: none;
  margin: 0 0.25rem;
}

.paginationContainer {
  display: flex;
  justify-content: center;
}

.selectedPaginationButton {
  background: #3d3732;
  color: white;
  border-radius: 5px;
}

.thumbnail {
  width: 150px;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 2px 3px #8a8a8a;
  cursor: pointer;
}

.thumbnailContainer {
  height: 100%;
  max-height: 450px;
  overflow: auto;
}

@media (max-width: 768px) {
  .mobile-only-display {
    display: block;
  }
  .non-mobile-display {
    display: none !important;
  }
  .carousel-wrapper {
    justify-content: center;
  }
}

@media only screen and (max-width: 768px) {
  .carousel-wrapper {
    padding: 0;
  }
  .paginationButton {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0rem;
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
</style>
